module.exports = __webpack_public_path__ + "img/zhu_xc4.0e932db0.jpg";